<template>
  <div class="thank-you-box">
    <PaymentThankYou
      v-if="bindResponse"
      :quoteResponse="quoteResponse"
      :bindResponse="bindResponse"
    ></PaymentThankYou>
    <SavedQuoteThankYou
      v-else-if="isLoggedIn"
      :quoteResponse="quoteResponse"
    ></SavedQuoteThankYou>
    <div v-else>
      <p class="thank-you-text">
        Thank You, {{ quoteForm.info.firstName }} {{ quoteForm.info.lastName }},
      </p>
      <p>
        Your quote number is
        <span class="quote-number-bold">{{
          quoteResponse.policies[0].policyNumber
        }}</span
        >.
      </p>
      <p>
        Thank you for your interest Porsche Auto Insurance. Like you, we believe
        your vehicle deserves coverage befitting a Porsche, and it is our great
        pleasure to welcome you onboard.
      </p>
      <p>
        You can access and purchase your policy by returning to this website via
        the email you receive with a link to your online quote, or you can call
        <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a> to speak to a
        customer service concierge.
      </p>
    </div>
    <div class="button-center-align">
      <button
        @click="continueToHomePage"
        type="button"
        class="button-primary button-primary--black -spacing-static-b"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair">
          <span class="loader-base button-primary__loader"></span>
        </span>

        <span class="button-primary__label">Continue to Homepage</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PaymentThankYou from './paymentThankYou';
import SavedQuoteThankYou from './savedQuoteThankYou';

export default {
  computed: {
    ...mapGetters(['quoteResponse', 'bindResponse', 'isLoggedIn'])
  },
  data: () => ({
    password: '',
    verifyPassword: '',
    hasMinimum: false,
    hasNumber: false,
    hasUppercase: false,
    hasLowercase: false,
    hasSpecial: false,
    passwordsMatch: false
  }),
  components: {
    PaymentThankYou,
    SavedQuoteThankYou
  },
  methods: {
    ...mapActions(['signUp']),
    ...mapMutations(['toggleLoader']),
    showSnackBar(options) {
      this.$snackbar.open(options);
    },
    submit() {
      let firstErrorField;
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (result) {
            let payload = {
              emailAddress:
                this.bindResponse.policies[0] &&
                this.bindResponse.policies[0].emailAddress,
              returnUrl: window.location.origin + '/account/',
              password: this.password
            };
            if (this.bindResponse) {
              payload.policyAddress = this.bindResponse.policies[0].policyNumber;
            } else if (this.quoteResponse) {
              payload.policyAddress = this.quoteResponse.policies[0].policyNumber;
            }
            this.toggleLoader({
              loaderText: 'Loading...'
            });
            this.signUp(payload)
              .then(() => {
                this.toggleLoader();
                this.showSnackBar({
                  type: 'is-success',
                  message: `Thank you for creating your account. You will receive an email shortly
                  containing a link to confirm your registration. Once confirmed,
                  your account will be activated and ready to use.`,
                  position: 'is-bottom',
                  duration: 10000
                });
                this.$router.replace('/');
              })
              .catch(() => {
                this.toggleLoader();
                this.showSnackBar({
                  type: 'is-danger',
                  message: '',
                  position: 'is-bottom'
                });
                let message = document.querySelector('.snackbar > .text');
                message.innerHTML = `The system is unable to complete your request at this time.
                Please call <nobr><a style="text-decoration:underline;color:#fff" href="tel:1-800-400-4128">800-400-4128</a></nobr>
                to speak to a customer service concierge.`;
              });
            resolve(true);
          } else {
            firstErrorField = this.$el.querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            );
            firstErrorField.focus();
            reject('invalid fields');
          }
        });
      });
    },
    checkPassword: function(e) {
      let val = e.target.value,
        verifyPassword = document.querySelector('input[name="verifyPassword"]')
          .value;

      if (val.length >= 10) {
        this.hasMinimum = true;
      } else {
        this.hasMinimum = false;
      }

      this.hasNumber = /\d/.test(val);
      this.hasUppercase = /[A-Z]/.test(val);
      this.hasLowercase = /[a-z]/.test(val);
      this.hasSpecial = /[!@#$%^&*)(+=._-]/.test(val);

      if (this.password === verifyPassword && this.password !== '') {
        this.passwordsMatch = true;
      } else {
        this.passwordsMatch = false;
      }
    },
    continueToHomePage() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.thank-you-box {
  padding-bottom: 10px;
  .thank-you-text {
    font-size: 24px;
  }

  .alert-danger {
    color: red;
  }

  .info-box {
    margin-bottom: 1rem;
  }
  .quote-number-bold {
    font-weight: bold;
  }
}
.password-requirements {
  color: $jumbo;
  font-size: 14px;
  list-style-type: none;
  padding-left: 0;

  li {
    padding-left: 20px;
    position: relative;

    &.has-passed {
      color: green;
    }
  }

  .icon {
    position: absolute;
    top: 4px;
    left: 0;
  }
}
.disabled_email {
  color: #737278;
}
</style>
